<template>
    <div>
        <div>
            <p class="title">GoldAmount</p>
            <div>
                Gold, silver and copper: <GoldAmount amount="581234"/>
                <br>
                Silver: <GoldAmount amount="234"/>
                <br>
                Copper: <GoldAmount amount="34"/>
                <br>
                Gold and copper: <GoldAmount amount="50034"/>
                <br>
                Negative: <GoldAmount amount="-581234"/>
                <br>
                Negative silver: <GoldAmount amount="-234"/>
                <br>
                Negative copper: <GoldAmount amount="-34"/>
            </div>
        </div>
        <div>
            <p class="title">Economics warning</p>
            <economics-warning/>
        </div>
        <div>
            <p class="title">Currency amount</p>
            Gold: <currency-amount amount="200" currency="Coppers" />
            <br>
            Karma: <currency-amount amount="200" currency="Karma" />
            <br>
            Laurels: <currency-amount amount="200" currency="Laurel" />
            <br>
            Negative laurels: <currency-amount amount="-20" currency="Laurel" />
            <br>
            Currency without icon: <currency-amount amount="200" currency="Cat" />
        </div>
    </div>
</template>

<script>
    import GoldAmount from '@/components/GoldAmount.vue'
    import EconomicsWarning from "@/components/EconomicsWarning";
    import CurrencyAmount from "@/components/CurrencyAmount";

    export default {
        name: "ComponentTest",
        components: {
            CurrencyAmount,
            GoldAmount,
            EconomicsWarning
        }
    }
</script>

<style scoped>

</style>